var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _path8, _rect6, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4861 70.7486H2.51386C1.84714 70.7486 1.20773 70.4838 0.736292 70.0123C0.264852 69.5409 0 68.9015 0 68.2348C27.1774 65.0762 53.8441 65.0762 80 68.2348C80 68.9015 79.7351 69.5409 79.2637 70.0123C78.7923 70.4838 78.1528 70.7486 77.4861 70.7486Z",
    fill: "#424A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68.3826L0 68.2347L9.27172 52.634L9.31608 52.5601V18.1778C9.31604 17.7605 9.39822 17.3472 9.55791 16.9617C9.7176 16.5761 9.95167 16.2258 10.2468 15.9307C10.5419 15.6356 10.8922 15.4015 11.2778 15.2418C11.6633 15.0821 12.0766 15 12.4939 15H67.0625C67.4798 15 67.893 15.0821 68.2786 15.2418C68.6642 15.4015 69.0145 15.6356 69.3096 15.9307C69.6047 16.2258 69.8388 16.5761 69.9985 16.9617C70.1581 17.3472 70.2403 17.7605 70.2403 18.1778V52.7967L80 68.3826Z",
    fill: "#57606A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4213 17.2184C12.1469 17.2187 11.8838 17.3278 11.6897 17.5219C11.4957 17.716 11.3865 17.9791 11.3862 18.2535V49.6029C11.3866 49.8773 11.4957 50.1404 11.6898 50.3344C11.8838 50.5285 12.1469 50.6377 12.4213 50.638H67.5784C67.8529 50.6376 68.116 50.5285 68.31 50.3344C68.5041 50.1404 68.6132 49.8773 68.6136 49.6029V18.2535C68.6132 17.9791 68.5041 17.716 68.31 17.5219C68.116 17.3279 67.8529 17.2187 67.5784 17.2184H12.4213Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6526 54.7786C12.5678 54.7788 12.4848 54.8032 12.4134 54.8489C12.342 54.8947 12.2852 54.9599 12.2496 55.0368L9.39267 61.2476C9.36157 61.3152 9.34797 61.3895 9.35311 61.4637C9.35826 61.5379 9.38199 61.6097 9.42213 61.6723C9.46226 61.7349 9.5175 61.7865 9.58277 61.8222C9.64804 61.8579 9.72124 61.8766 9.79564 61.8766H69.8749C69.9505 61.8766 70.0248 61.8573 70.0909 61.8204C70.1569 61.7836 70.2125 61.7305 70.2522 61.6662C70.292 61.6019 70.3146 61.5284 70.318 61.4529C70.3214 61.3774 70.3054 61.3022 70.2716 61.2346L67.1662 55.0238C67.1296 54.95 67.073 54.8879 67.0029 54.8446C66.9328 54.8012 66.8519 54.7784 66.7695 54.7786H12.6526Z",
    fill: "#424A53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8726 63.0599C33.7751 63.06 33.6803 63.0922 33.6029 63.1515C33.5255 63.2108 33.4698 63.294 33.4443 63.3881L32.7277 66.0499C32.71 66.1156 32.7076 66.1845 32.7208 66.2513C32.734 66.3181 32.7625 66.381 32.8039 66.4351C32.8453 66.4891 32.8986 66.5329 32.9597 66.563C33.0207 66.5932 33.0879 66.6089 33.156 66.6089H46.7846C46.8554 66.6089 46.9251 66.5919 46.9879 66.5595C47.0508 66.5271 47.105 66.4801 47.146 66.4225C47.187 66.3649 47.2136 66.2983 47.2237 66.2283C47.2337 66.1583 47.2269 66.0869 47.2037 66.0201L46.2824 63.3584C46.2522 63.2712 46.1956 63.1957 46.1204 63.1422C46.0453 63.0887 45.9554 63.0599 45.8632 63.0599H33.8726Z",
    fill: "#424A53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.24 52.0426V52.634H9.27148L9.31737 52.5602V52.0426H70.24Z",
    fill: "#424A53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7782 16.7003C40.1457 16.7003 40.4437 16.4024 40.4437 16.0349C40.4437 15.6674 40.1457 15.3694 39.7782 15.3694C39.4107 15.3694 39.1128 15.6674 39.1128 16.0349C39.1128 16.4024 39.4107 16.7003 39.7782 16.7003Z",
    fill: "#424A53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1665,
    y: 28.3333,
    width: 6.66667,
    height: 16.6667,
    fill: "#AFB8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.833,
    y: 34.1666,
    width: 6.66667,
    height: 10.8333,
    fill: "#AFB8C1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 24.1666,
    width: 6.66667,
    height: 20.8333,
    fill: "#AFB8C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1665,
    y: 30,
    width: 6.66667,
    height: 15,
    fill: "#AFB8C1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 5.83331,
    width: 20.8333,
    height: 20.8333,
    rx: 3.33333,
    fill: "#71BEF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1665 21.56V22.4467C74.1665 22.9359 73.7664 23.3333 73.2736 23.3333H62.5594C62.0666 23.3333 61.6665 22.9359 61.6665 22.4467V21.5458C61.6665 18.8629 64.7541 17.1197 67.9165 17.1197C71.0789 17.1197 74.1665 18.8639 74.1665 21.5458V21.56ZM70.1583 10.0766C71.3965 11.2899 71.3965 13.257 70.1583 14.47C68.9202 15.6833 66.9128 15.6833 65.6747 14.47C64.4369 13.257 64.4369 11.2899 65.6747 10.0766C66.9128 8.8633 68.9202 8.8633 70.1583 10.0766Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 37.5,
    width: 20.8333,
    height: 20.8333,
    rx: 3.33333,
    fill: "#71BEF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 53.2267V54.1134C18.333 54.6026 17.933 55 17.4401 55H6.72587C6.23306 55 5.83301 54.6026 5.83301 54.1134V53.2125C5.83301 50.5296 8.92064 48.7863 12.083 48.7863C15.2454 48.7863 18.333 50.5306 18.333 53.2125V53.2267ZM14.3248 41.7433C15.563 42.9566 15.563 44.9237 14.3248 46.1367C13.0867 47.35 11.0794 47.35 9.84121 46.1367C8.60338 44.9237 8.60338 42.9566 9.84121 41.7433C11.0794 40.53 13.0867 40.53 14.3248 41.7433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.1538d5594f3e10f66356ef936a531690.svg";
export { ForwardRef as ReactComponent };